export const formatAmount = (amount) =>
    `KES ${Number(amount).toLocaleString('en-KE', { minimumFractionDigits: 2 })}`

export const formatDate = (dateString) =>
    new Date(dateString).toLocaleString('en-KE', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    })

export const formatPerson = (person) => {
    if (!person) return '-'
    const name = (person.name ?? '').trim() || '-'
    if (!person.is_deleted) return name
    return (
        <>
            {name}
            <span className="text-muted ms-1" style={{ fontSize: '0.75rem' }}>(deleted)</span>
        </>
    )
}

export const formatInitiator = formatPerson
